import React, { PropsWithChildren } from 'react';
import { Box, Divider, Pane, Typography } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';

const DefaultPadding = 16;

export interface EngagementMapsDetailsCardProps {
  /**
   * The name of the Engagement Map.
   */
  name: string;
}

/**
 * A details card used to display information about the data or segment for the Engagement Map.
 * A caller can pass in more details / control mechanisms via the children of this component.
 */
export const EngagementMapsDetailsCard: React.FC<
  PropsWithChildren<EngagementMapsDetailsCardProps>
> = ({ name, children }) => (
  <Pane
    data-component="EngagementMapsDetailsCard"
    data-fs="engagement-maps-details-card"
    backgroundColor="default"
    padding={DefaultPadding}
  >
    <Box paddingBottom={8}>
      <Typography variant="heading7" color="neutrals-n7">
        <FormattedMessage defaultMessage="{name} Details" id="xDyI05" values={{ name }} />
      </Typography>
    </Box>
    <Box paddingBottom={DefaultPadding}>
      <Divider variant="medium" />
    </Box>
    {children}
  </Pane>
);
